var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithoutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 62,
    viewBox: "0 0 108 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52248",
    "data-name": "Group 52248",
    transform: "translate(-141 -359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52236",
    "data-name": "Group 52236",
    transform: "translate(16607 1114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9376",
    "data-name": "Rectangle 9376",
    transform: "translate(-16466 -755)",
    fill: "#fff",
    stroke: "#b2b2bf",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 62,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 107.5,
    height: 61.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9372",
    "data-name": "Rectangle 9372",
    transform: "translate(-16458 -747)",
    fill: "#d1d6dd",
    stroke: "#d1d6dd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 90.5,
    height: 46.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9378",
    "data-name": "Rectangle 9378",
    transform: "translate(171 367)",
    fill: "#d1d6dd",
    stroke: "#d1d6dd",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 46.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_Copy_211",
    "data-name": "Rectangle Copy 211",
    transform: "translate(170 377)",
    fill: "#f1f1f5",
    stroke: "#b2b2bf",
    strokeWidth: 1,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.233,
    height: 27.711,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47.233,
    height: 26.711,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutImage);
export default __webpack_public_path__ + "static/media/withoutImage.e2ff5cfe83382a896b78ddfbc4ab17cb.svg";
export { ForwardRef as ReactComponent };